import { Bar, BarChart, CartesianGrid, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { formatDay } from './formatDay';

export const REAL_COLOR = '#2f80ed';
export const FALSE_POSITIVE_COLOR = '#d6547e';

function BugVerdictsChart({ data }) {
  return (
    <div>
      <div className="sense-shield-panel-title">Real Bugs vs False Positives</div>
      <p className="sense-shield-panel-description">Jira tickets created per day: real bugs (shield-qa) and false positives to fix in Shield (shield-improvement)</p>
      <div className="sense-shield-panel-content">
        {!data || data.length === 0 ? (
          <div className="sense-shield-empty">No verdict data available</div>
        ) : (
          <ResponsiveContainer width="100%" height={220}>
            <BarChart data={data} margin={{ top: 30, right: 20, left: 0, bottom: 10 }}>
              <CartesianGrid strokeDasharray="3 3" vertical={false} />
              <XAxis dataKey="day" tick={{ fontSize: 11 }} tickFormatter={formatDay} />
              <YAxis tick={{ fontSize: 11 }} allowDecimals={false} />
              <Tooltip />
              <Legend verticalAlign="top" align="left" wrapperStyle={{ fontSize: 12 }} />
              <Bar dataKey="real" name="Real bug" stackId="v" fill={REAL_COLOR} />
              <Bar dataKey="falsePositive" name="False positive" stackId="v" fill={FALSE_POSITIVE_COLOR} />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </div>
  );
}

export default BugVerdictsChart;
